import { getSeededRandomFromString } from "../../engine/HelperFunctions/getSeededRandomFromString";
import { SkinColorsEnum } from "../Types/SkinColors";
import { EthnicitySkinColorMap } from "../Data/EthnicitySkinColorMap";
import { getEthnicityFromRand } from "./getEthnicityFromRand";
import { CharacterPortraitGenerator } from "./CharacterPortraitGenerator";
import { getAgeFromRand } from "./getAgeFromRand";
import { CharacterCreatorDefinition } from "../Constants/CharacterCreatorDefinition";
import { RenderTexture } from "pixi.js";
import { stringHash } from "../../engine/HelperFunctions/stringHash";
import { SeededRandom } from "../../engine/SeededRandom";

let singleton: CharacterPortraitGenerator;

export function createPatientPictureFromPatientName(_patientName: string): RenderTexture {
    if(!singleton) {
        singleton = new CharacterPortraitGenerator();
    }

    const seed = stringHash(_patientName);
    const seededRandom = new SeededRandom(seed);
    const randOrig_unAbs = seededRandom.next();
    const randOrig = Math.abs(randOrig_unAbs);
    let rand1 = randOrig;
    let rand2 = Math.abs(seededRandom.next());

    // "chosen by fair dice roll."
    // "guaranteed to be random."
    if(rand1 < 0.1) {
        rand1 = Math.abs(seededRandom.next());
    }
    if(rand2 < 0.1) {
        rand2 = Math.abs(seededRandom.next());
    }

    let skinColor: SkinColorsEnum;
    if(randOrig_unAbs < 0) {
        // randomise skin color
        skinColor = Math.floor(SkinColorsEnum.NUM_OF_SKIN_COLORS * randOrig);
    } else {
        const ethnMap = EthnicitySkinColorMap[
            getEthnicityFromRand(randOrig)
        ];
        skinColor = ethnMap[Math.floor(ethnMap.length * rand2)];
    }
    singleton.update({
        earsVal: Math.floor(CharacterCreatorDefinition.earFronts.length * rand1),
        skinColor: skinColor,
        desaturateHair: getAgeFromRand(randOrig) > 50 ? true : false,
        hairTint: Math.floor(CharacterCreatorDefinition.hairtints.length * rand1),
        faceVal: Math.floor(CharacterCreatorDefinition.faces.length * rand1),
        eyesVal: Math.floor(CharacterCreatorDefinition.eyes.length * rand2),
        mouthVal: Math.floor(CharacterCreatorDefinition.mouths.length * rand1),
        noseVal: Math.floor(CharacterCreatorDefinition.noses.length * rand2),
        hairVal: Math.floor(CharacterCreatorDefinition.hairback.length * rand1),
        eyebrowsVal: Math.floor(CharacterCreatorDefinition.eyebrows.length * rand2),
    });
    const texture = singleton.createPortraitTexture();
    return texture;
}